const GaauPriorityEnum = {
  Low: "Baixo",
  Average: "Médio",
  High: "Alto",
  Priority: "Prioritário"
};

export default GaauPriorityEnum;
